import { useEffect, useState } from 'react';
import { api, type Me } from './api.js';
import { Login } from './pages/Login.js';
import { ProjectPage } from './pages/ProjectPage.js';
import { Projects } from './pages/Projects.js';
import { Settings } from './pages/Settings.js';
import { Share } from './pages/Share.js';
import { useRoute } from './router.js';

export function App() {
  const [me, setMe] = useState<Me | null | undefined>(undefined);
  const route = useRoute();

  useEffect(() => {
    api<{ user: Me }>('GET', '/api/me').then((r) => setMe(r.user), () => setMe(null));
  }, []);

  if (me === undefined) return <p className="loading">Loading…</p>;
  if (me === null) return <Login onSignedIn={setMe} />;
  if (route.name === 'project') return <ProjectPage key={route.id} me={me} projectId={route.id} view={route.view} focus={route.focus} />;
  if (route.name === 'share') return <Share me={me} />;
  if (route.name === 'settings') return <Settings me={me} />;
  return <Projects me={me} />;
}
